import { formatDateSafe } from '@/utils/dateUtils';

export type IndicatorTone = 'neutral' | 'muted' | 'warning' | 'danger' | 'success';

export const INDICATOR_CARD_CLASSES: Record<IndicatorTone, string> = {
    neutral: 'border-gray-200 bg-white',
    muted: 'border-gray-200 bg-white',
    warning: 'border-amber-200 bg-amber-50',
    danger: 'border-red-200 bg-red-50',
    success: 'border-emerald-200 bg-emerald-50',
};

export const INDICATOR_LABEL_CLASSES: Record<IndicatorTone, string> = {
    neutral: 'text-gray-500',
    muted: 'text-gray-500',
    warning: 'text-amber-700',
    danger: 'text-red-700',
    success: 'text-emerald-700',
};

export const INDICATOR_VALUE_CLASSES: Record<IndicatorTone, string> = {
    neutral: 'text-gray-900',
    muted: 'text-gray-400',
    warning: 'text-amber-800',
    danger: 'text-red-800',
    success: 'text-emerald-700',
};

export const INDICATOR_ICON_CLASSES: Record<IndicatorTone, string> = {
    neutral: 'text-indigo-500',
    muted: 'text-gray-300',
    warning: 'text-amber-500',
    danger: 'text-red-500',
    success: 'text-emerald-500',
};

export const INDICATOR_CAPTION_CLASSES: Record<IndicatorTone, string> = {
    neutral: 'text-gray-500',
    muted: 'text-gray-400',
    warning: 'text-amber-700',
    danger: 'text-red-700',
    success: 'text-emerald-700',
};

export const INDICATOR_LABELS = {
    balance: 'Saldo',
    expiring: 'Férias a Vencer',
    deadline: 'Limite para agendar',
    status: 'Situação',
    scheduled: 'Dias Agendados',
} as const;

export const NO_DEADLINE = 'Sem prazo';
export const NO_DEADLINE_CAPTION = 'nenhum período com saldo a vencer';
export const EXPIRED_CAPTION = 'prazo vencido';
export const TODAY_CAPTION = 'é hoje';
export const EXPIRING_CAPTION = 'dias que perdem a validade';
export const SCHEDULED_CAPTION = 'ainda não iniciados';

export const IDLE_VALUES = {
    upToDate: 'Férias em dia',
    allScheduled: 'Férias agendadas',
} as const;

export const DEADLINE_WARNING_DAYS = 30;

export function buildRemainingCaption(daysLeft: number | null): string | null {
    if (daysLeft === null) return NO_DEADLINE_CAPTION;
    if (daysLeft < 0) return EXPIRED_CAPTION;
    if (daysLeft === 0) return TODAY_CAPTION;
    return daysLeft === 1 ? 'falta 1 dia' : `faltam ${daysLeft} dias`;
}

export function resolveDeadlineTone(daysLeft: number | null): IndicatorTone {
    if (daysLeft === null) return 'muted';
    if (daysLeft < 0) return 'danger';
    return daysLeft <= DEADLINE_WARNING_DAYS ? 'warning' : 'neutral';
}

export function pluralDays(days: number): string {
    return days === 1 ? 'dia' : 'dias';
}

export function buildIdleCaption(
    variant: 'upToDate' | 'allScheduled',
    nextEntitlementDate: string | null
): string {
    const prefix = variant === 'upToDate' ? 'sem limite a cumprir' : 'sem limite pendente';
    if (!nextEntitlementDate) {
        return prefix;
    }
    return `${prefix} · próximo direito ${formatDateSafe(nextEntitlementDate)}`;
}
